import React from 'react'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'

type Props = {}

const NotFountPage = (props: Props) => {
  return (
    <>
    <Header />
    <div>
        <h1>Error 404. Página no encontrada</h1>
    </div>
    <Footer />
    </>
  )
}

export default NotFountPage